module.exports = __webpack_public_path__ + "img/category_cover_New.3e5acf9.webp";